import { config } from 'src/constants'

import axios from 'axios'

export const fetchHistory = async () => {
  return await axios(`${config.API_URL3}/${window.busytable.brandSlug}/history`, {
    withCredentials: true
  })
}
